import React, { ReactNode, CSSProperties } from 'react';
import './infoCard.css';

export interface InfoCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  titleStyle?: CSSProperties;
  descriptionStyle?: CSSProperties;
  cardStyle?: CSSProperties;
  contentStyle?: CSSProperties;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  icon,
  title,
  description,
  className = '',
  style,
  iconStyle,
  titleStyle,
  descriptionStyle,
  cardStyle,
  contentStyle,
}) => {
  return (
    <div 
      className={`info-card ${className}`}
      style={{ ...style, ...cardStyle }}
    >
      <div 
        className="info-card__icon"
        style={iconStyle}
      >
        {icon}
      </div>
      <div 
        className="info-card__content"
        style={contentStyle}
      >
        <h3 
          className="info-card__title"
          style={titleStyle}
        >
          {title}
        </h3>
        <p 
          className="info-card__text"
          style={descriptionStyle}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
